/** Angular */
import { HttpHandler, HttpEvent, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
/** Sixense */
import { DsLibSnackbar, DsLibSnackbarStates } from '@sixense/ds-lib-common';
/** Enums */
import { HttpErrorMessagesEnum } from '@core/enums/http-error-messages.enum';
import { HttpStatusCodeEnum } from '@core/enums/http-status-code.enum';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class DsErrorsInterceptorService implements HttpInterceptor {
  /**
   * How long the error snackbar will appear before dismissing automaticaly.
   */
  private snackbarDuration = 10000;

  /**
   *
   */
  private errorFilter: Map<RegExp, number[]> = new Map<RegExp, number[]>();

  /**
   * Creates an instance of DsErrorsInterceptorService.
   *
   * @param dsLibSnackbar service to dispatch Material Design snack bar messages using a unified ds-lib service.
   * @param translate trasnlate service
   */
  constructor(private dsLibSnackbar: DsLibSnackbar, private translate: TranslateService) {
    // Exception for the document creation in Nuxeo
    let regexp = new RegExp('nuxeo/api/v1/sixenseged/projects/[0-9]+/categories/.*/documents');
    this.errorFilter.set(regexp, [409]);
    // Exception for the document download
    regexp = new RegExp('nuxeo/api/v1/sixenseged/projects/download');
    this.errorFilter.set(regexp, [404]);
  }

  /**
   * Errors interceptor.
   *
   * @param req HTTP request
   * @param next handler instance dispatches requests
   * @returns Observable<HttpEvent<any>>
   */
  // TODO: set the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(catchError((err) => this.handleError(err)));
  }

  /**
   * Errors handler.
   *
   * @param httpErrorResponse Response that represents an error or failure
   * @returns throwError
   */
  // TODO: set the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public handleError(httpErrorResponse: HttpErrorResponse): Observable<any> {
    // Checks if the error doesn't match an exception case from its url and status
    let isErrorFiltered = false;
    this.errorFilter.forEach((status, regexp) => {
      if (
        !isErrorFiltered &&
        httpErrorResponse.url &&
        regexp.test(httpErrorResponse.url) &&
        status.includes(httpErrorResponse.status)
      ) {
        isErrorFiltered = true;
      }
    });

    if (!isErrorFiltered && httpErrorResponse.status !== HttpStatusCodeEnum.UNAUTHORIZED) {
      const error: string = httpErrorResponse.error.message || httpErrorResponse.statusText;
      this.dsLibSnackbar.open(
        {
          text:
            error === HttpErrorMessagesEnum.INVALID || httpErrorResponse.status === HttpStatusCodeEnum.FORBIDDEN
              ? `errors.${httpErrorResponse.error.statusCode || httpErrorResponse.status}`
              : 'errors.defaultError',
          translateArgs: { error: this.translate.instant(`errors.${error}`) },
          state: DsLibSnackbarStates.WARN,
        },
        this.snackbarDuration
      );
    }
    return throwError(httpErrorResponse);
  }
}
